import moment from "moment";
import { findIndex, propEq } from "ramda";
import { IDENTITY_SYSTEM } from "../module/constants";
import {
  statusIdCode,
  statusIdLowerCase,
  statusIdString,
} from "../pages/ExternalPortal/module/constants";

interface searchByKeyObjectInArrayProps {
  key: string;
  value: string | number | boolean;
  array: any[];
  index?: boolean;
}
export const searchByKeyObjectInArray = (
  props: searchByKeyObjectInArrayProps
): boolean | number => {
  const { key, value, array, index = false } = props;
  if (index) return findIndex(propEq(key, value))(array);
  if (findIndex(propEq(key, value))(array) >= 0) return true;
  return false;
};

export const printStringArray = (stringArray: string[]) => {
  let strToPrint = "";
  let first = true;
  if (stringArray && stringArray.length > 0) {
    stringArray.forEach((stringOfArray) => {
      if (first) {
        strToPrint += stringOfArray;
        first = false;
      } else {
        strToPrint += `, ${stringOfArray}`;
      }
    });
  }
  return strToPrint;
};

export const formatDateFromMillisecondsStringToDDMMYYYY = (
  milliseconds: string
) => {
  return moment(new Date(Number(milliseconds))).format("DD/MM/YYYY");
};

export const formatDateFromDDMMYYYYToMilliseconds = (date: string) => {
  let tempList = date.split("/");
  let newDate = tempList[1] + "/" + tempList[0] + "/" + tempList[2];
  return new Date(newDate).getTime();
};

export const xnor = (a: boolean, b: boolean) => {
  return a === b;
};

export const convertStoredFilterToState = (
  filter: { values: any },
  config?: {
    isServerSide?: boolean;
    typeFilter?: any;
    allFilter?: boolean;
    allFilterKey?: string[];
  }
): any[] => {
  const resultFilter: any[] = [];

  if (filter && filter.values) {
    if (!config || !config.allFilter) {
      Object.keys(filter.values).forEach((key) => {
        if (key) {
          const filterElement = {
            id: config && config.typeFilter ? config.typeFilter[key] : key,
            value:
              key === "identitySystemIdFilter" && config && !config.isServerSide
                ? IDENTITY_SYSTEM[
                    filter.values[key] as keyof typeof IDENTITY_SYSTEM
                  ]
                : key === "statusIdFilter"
                ? filter.values[key] === statusIdString.CESSATO
                  ? [
                      statusIdCode.CESSATO_CONS,
                      statusIdCode.CESSATO_OUTS,
                      statusIdLowerCase.Cessato,
                    ]
                  : filter.values[key] === statusIdString.NON_IN_SERVIZIO
                  ? [
                      statusIdCode.NON_IN_SERVIZIO_CONS,
                      statusIdCode.NON_IN_SERVIZIO_OUTS,
                      statusIdLowerCase.Non_In_Servizio,
                    ]
                  : filter.values[key] === statusIdString.IN_SERVIZIO
                  ? [statusIdCode.IN_SERVIZIO, statusIdLowerCase.In_Servizio]
                  : [
                      statusIdCode[
                        filter.values[key] as keyof typeof statusIdCode
                      ],
                    ]
                : filter.values[key],
            operation: "AND",
          };
          if (filterElement.id) {
            resultFilter.push(filterElement);
          }
        }
      });
    } else {
      config.allFilterKey?.forEach((key) => {
        resultFilter.push({
          id: key,
          value: filter.values["allFilter"],
          operation: "OR",
        });
      });
    }
  }

  return resultFilter;
};

export const getTargetIdBasedOnEnv = () => {
  let targetId;
  const host = window.location.host;

  if (
    host.includes("intapi") ||
    host.includes("10.1.18.12") ||
    host.includes("localhost")
  ) {
    targetId = "1";
  } else if (
    host.includes("stguigp") ||
    host.includes("10.222.212.183") ||
    host.includes("10.222.212.184") ||
    host.includes("10.111.76.33") ||
    host.includes("10.111.75.33")
  ) {
    targetId = "8107";
  } else {
    targetId = "13102";
  }
  return targetId;
};

export const parseStringToJson = (str: string, key?: string): boolean => {
  try {
    if (key) {
    } else {
    }
  } catch (error) {
    return false;
  }
  return true;
};

const NUMBER_CHECK_REGEX = "[\\(\\)\\+\\sa-zA-Z]";
export const sanitizeMobileNumber = (mobile: string) => {
  let str = mobile;
  const regex = new RegExp(NUMBER_CHECK_REGEX, "g");

  if (str.match(regex)) {
    str = str.replaceAll(regex, "");
  }

  return str;
};

export const generateEscapedRegexPattern = (charList: string[]): string => {
  return charList.map((char) => "\\" + char).join("");
};

export const checkPwdContainsOnlyAllowedSpecialChars = (
  str: string,
  pattern: string,
  min: number
): boolean => {
  const sanitizedStr = str.replaceAll(new RegExp("[a-zA-Z0-9]", "g"), "");
  const allowedRegex = new RegExp(`[${pattern ? pattern : ""}]{${min},}`, "g");
  const inverseRegex = new RegExp(`(?![${pattern}]|$)`, "g");

  if (allowedRegex.test(sanitizedStr) && !inverseRegex.test(sanitizedStr)) {
    return true;
  }
  return false;
};

export const checkPwdNotContainsSpecialChars = (str: string): boolean => {
  const regex = new RegExp(/(?![a-zA-Z0-9]|$)/g);
  return regex.test(str) ? false : true;
};

export const convertDisplayedDateToDate = (date: string): Date => {
  if (!date) return new Date();
  const dateArray = date.split("/");
  const returnedDate = new Date(
    `${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`
  );
  return returnedDate;
};

/**
 * Estrae e formatta le date di inizio e fine dal filtro
 * @param {Array} filter - Array di filtri contenente i filtri applicati
 * @returns {Object} Oggetto contenente startDate ed endDate come timestamp
 */
export const extractDateRange = (filter: any[], filterName: string) => {
  // Validazione
  if (!Array.isArray(filter)) {
    console.warn("extractDateRange: filter deve essere un array");
    return { startDate: null, endDate: null };
  }

  if (!filterName || typeof filterName !== "string") {
    console.warn("extractDateRange: filterName deve essere una stringa valida");
    return { startDate: null, endDate: null };
  }

  // Trova il filtro per le date
  const dateFilter = filter.find(
    (filterElement) => filterElement?.id === filterName
  );

  // Se non trova il filtro o non ha valori, ritorna null
  if (!dateFilter?.value || !Array.isArray(dateFilter.value)) {
    return { startDate: null, endDate: null };
  }

  let startDate = null;
  let endDate = null;

  try {
    // Data di inizio - mantieni l'inizio della giornata
    if (dateFilter.value[0]) {
      const start = new Date(dateFilter.value[0]);
      if (isNaN(start.getTime())) {
        console.warn("extractDateRange: startDate non è una data valida");
      } else {
        startDate = start.getTime();
      }
    }

    // Data di fine - imposta alla fine della giornata
    if (dateFilter.value[1]) {
      const end = new Date(dateFilter.value[1]);
      if (isNaN(end.getTime())) {
        console.warn("extractDateRange: endDate non è una data valida");
      } else {
        end.setHours(23, 59, 59, 999);
        endDate = end.getTime();
      }
    }
  } catch (error) {
    console.error("extractDateRange: Errore nel parsing delle date", error);
    return { startDate: null, endDate: null };
  }

  return {
    startDate,
    endDate,
  };
};

// intl translation check for null/undefined
export const getMessageProps = (
  messagesObject: any,
  key: string | undefined | null
) => {
  const safeKey = typeof key === "string" ? key : String(key);
  const message = messagesObject?.[safeKey];
  if (message && typeof message === "object" && message.id) {
    return message;
  }
};
